module.exports = __webpack_public_path__ + "files/60f86d6c4bad5436cccc5a11c840cffa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/googleLogo.png
 ** module id = 810
 ** module chunks = 0
 **/